<template>
  <div class="_switch">
    <input type="checkbox" id="theme-switch" @click="toggleTheme">
    <label for="theme-switch" :class="{ 'diana-dark': theme === dianaDark, 'diana-light': theme === dianaLight }">
      <span class="_slider" :style="{ backgroundColor: $store.state.buttonColor }">
        <svg v-if="theme === dianaDark" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.99984 6C9.09984 6 9.99984 6.9 9.99984 8C9.99984 9.1 9.09984 10 7.99984 10C6.89984 10 5.99984 9.1 5.99984 8C5.99984 6.9 6.89984 6 7.99984 6ZM7.99984 4.66667C6.15984 4.66667 4.6665 6.16 4.6665 8C4.6665 9.84 6.15984 11.3333 7.99984 11.3333C9.83984 11.3333 11.3332 9.84 11.3332 8C11.3332 6.16 9.83984 4.66667 7.99984 4.66667ZM1.33317 8.66667H2.6665C3.03317 8.66667 3.33317 8.36667 3.33317 8C3.33317 7.63333 3.03317 7.33333 2.6665 7.33333H1.33317C0.966504 7.33333 0.666504 7.63333 0.666504 8C0.666504 8.36667 0.966504 8.66667 1.33317 8.66667ZM13.3332 8.66667H14.6665C15.0332 8.66667 15.3332 8.36667 15.3332 8C15.3332 7.63333 15.0332 7.33333 14.6665 7.33333H13.3332C12.9665 7.33333 12.6665 7.63333 12.6665 8C12.6665 8.36667 12.9665 8.66667 13.3332 8.66667ZM7.33317 1.33333V2.66667C7.33317 3.03333 7.63317 3.33333 7.99984 3.33333C8.3665 3.33333 8.6665 3.03333 8.6665 2.66667V1.33333C8.6665 0.966668 8.3665 0.666668 7.99984 0.666668C7.63317 0.666668 7.33317 0.966668 7.33317 1.33333ZM7.33317 13.3333V14.6667C7.33317 15.0333 7.63317 15.3333 7.99984 15.3333C8.3665 15.3333 8.6665 15.0333 8.6665 14.6667V13.3333C8.6665 12.9667 8.3665 12.6667 7.99984 12.6667C7.63317 12.6667 7.33317 12.9667 7.33317 13.3333ZM3.99317 3.05333C3.73317 2.79333 3.3065 2.79333 3.05317 3.05333C2.79317 3.31333 2.79317 3.74 3.05317 3.99333L3.75984 4.7C4.01984 4.96 4.4465 4.96 4.69984 4.7C4.95317 4.44 4.95984 4.01333 4.69984 3.76L3.99317 3.05333ZM12.2398 11.3C11.9798 11.04 11.5532 11.04 11.2998 11.3C11.0398 11.56 11.0398 11.9867 11.2998 12.24L12.0065 12.9467C12.2665 13.2067 12.6932 13.2067 12.9465 12.9467C13.2065 12.6867 13.2065 12.26 12.9465 12.0067L12.2398 11.3ZM12.9465 3.99333C13.2065 3.73333 13.2065 3.30667 12.9465 3.05333C12.6865 2.79333 12.2598 2.79333 12.0065 3.05333L11.2998 3.76C11.0398 4.02 11.0398 4.44667 11.2998 4.7C11.5598 4.95333 11.9865 4.96 12.2398 4.7L12.9465 3.99333ZM4.69984 12.24C4.95984 11.98 4.95984 11.5533 4.69984 11.3C4.43984 11.04 4.01317 11.04 3.75984 11.3L3.05317 12.0067C2.79317 12.2667 2.79317 12.6933 3.05317 12.9467C3.31317 13.2 3.73984 13.2067 3.99317 12.9467L4.69984 12.24Z" fill="white"/>
        </svg>
        <svg v-else width="15" height="15" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.24667 1.67333C4.12667 2.1 4.06667 2.54667 4.06667 3C4.06667 5.72 6.28 7.93333 9 7.93333C9.45333 7.93333 9.9 7.87333 10.3267 7.75333C9.63333 9.46 7.95333 10.6667 6 10.6667C3.42667 10.6667 1.33333 8.57333 1.33333 6C1.33333 4.04667 2.54 2.36667 4.24667 1.67333ZM6 0C2.68667 0 0 2.68667 0 6C0 9.31333 2.68667 12 6 12C9.31333 12 12 9.31333 12 6C12 5.69333 11.9733 5.38667 11.9333 5.09333C11.28 6.00667 10.2133 6.6 9 6.6C7.01333 6.6 5.4 4.98667 5.4 3C5.4 1.79333 5.99333 0.72 6.90667 0.0666666C6.61333 0.0266666 6.30667 0 6 0Z" fill="white"/>
        </svg>
      </span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'ThemeSwitch',
  data:() => ({
    theme: 'diana-dark',
    dianaDark: 'diana-dark',
    dianaLight: 'diana-light'
  }),
  mounted() {
    this.getTheme()
    document.body.setAttribute('data-theme', this.theme);
  },
  methods: {
    toggleTheme() {
      this.theme = this.theme === this.dianaDark ? this.dianaLight : this.dianaDark;
      this.setTheme();
    },
    setTheme() {
      document.body.setAttribute('data-theme', this.theme);
      try {
        localStorage.setItem('theme', this.theme);
      } catch (err) {
        console.error('Error setting theme in local storage:', err);
      }
    },
    getTheme() {
      try {
        const theme = localStorage.getItem('theme');
        if (theme) {
          this.theme = theme;
        }
      } catch (err) {
        console.error('Error getting theme from local storage:', err);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
._switch {
  display: inline-block;
  position: relative;
  width: 44px;
  height: 22px;

  #theme-switch {
    display: none;
  }

  ._slider {
    position: absolute;
    display: flex;
    align-items: center;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transition: 0.4s;
    border-radius: 34px;

    &:before {
      position: absolute;
      content: "";
      height: 18px;
      width: 18px;
      background-color: white;
      transition: 0.4s;
      border-radius: 50%;
      bottom: 2px;
    }

    svg {
      position: absolute;
      margin: 3px;
    }
  }

  .diana-dark {
    svg {
      left: 0;
    }

    ._slider:before {
      right: 2px;
    }
  }

  .diana-light {
    svg {
      right: 0;
    }

    ._slider:before {
      right: auto;
      left: 2px;
    }
  }
}
</style>
